module.exports = __webpack_public_path__ + "static/media/icon-star.84fdd16b.svg";